import { POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerViajeChecklist(obj) {
    try {
        let rows = null;
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/viaje-checklist/obtener-viaje-checklist/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            rows = body;
        }
        return rows;
    } catch (err) {
        console.log("obtenerViajeChecklist err");
        console.log(err);
        return [];
    }
}

export async function guardarViajeChecklist(obj) {
    try {
        let guardo = { error: false, id: -1 };
        const { code, id } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/viaje-checklist/guardar-viaje-checklist/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('id');
        // console.log(id);
        if (code === SUCCESS) {
            guardo.id = id;
        }
        return guardo;
    } catch (err) {
        console.log("guardarViajeChecklist err");
        console.log(err);
        return { error: false, id: -1 };
    }
}

export async function deshabilitarViajeChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/viaje-checklist/deshabilitar-viaje-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        console.log('code');
        console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("deshabilitarViajeChecklist err");
        console.log(err);
        return false;
    }
}

export async function habilitarViajeChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/viaje-checklist/habilitar-viaje-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        console.log('code');
        console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("habilitarViajeChecklist err");
        console.log(err);
        return false;
    }
}

export async function intercambiarPosicionViajeChecklist(obj) {
    try {
        let response = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/viaje-checklist/intercambiar-posicion-viaje-checklist",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        console.log('code');
        console.log(code);
        if (code === SUCCESS) {
            response = true;
        }
        return response;
    } catch (err) {
        console.log("intercambiarPosicionViajeChecklist err");
        console.log(err);
        return false;
    }
}